import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import glamorous from "glamorous";
import { StringValue } from "react-values";
import OkIcon from "react-icons/lib/io/android-checkmark-circle";
import WarningIcon from "react-icons/lib/io/android-warning";

import Colors from "../../styles/colors";
import GeofenceType, {
  allowedGeojsonFeatureTypes,
  getType
} from "./geofence-types";
import { RadialForm } from "./GeofenceEditRadialForm";
import { PolygonalForm } from "./GeofenceEditPolygonalForm";

const FenceValidityMarker = ({ isValid }) => {
  const color = isValid ? Colors.highlight.GREEN : Colors.highlight.RED;
  const nougat = isValid ? (
    <React.Fragment>
      <OkIcon /> Valid Fence
    </React.Fragment>
  ) : (
    <React.Fragment>
      <WarningIcon /> Invalid Fence
    </React.Fragment>
  );
  return (
    <glamorous.P marginLeft="1.5em" color={color} fontSize="0.9em">
      {nougat}
    </glamorous.P>
  );
};

export const FlexRow = glamorous.div(
  {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline"
  },
  ({ styleOverrides }) => {
    return styleOverrides;
  }
);

const ButtonTab = glamorous.div(
  {
    backgroundColor: "#eee",
    color: "black",
    fontWeight: "bold",
    padding: "0.5em 2em",
    borderRadius: "1px",
    cursor: "pointer"
  },
  ({ tabKey, selectedKey }) => {
    const isSelected = tabKey === selectedKey;
    if (isSelected) {
      return {
        backgroundColor: Colors.highlight.GREEN,
        color: "white"
      };
    }
  }
);

const ButtonTabLabel = glamorous.p({
  marginLeft: "0.5em",
  marginRight: "1.5em",
  fontWeight: "bold"
});

const GeofenceTypeToggleBar = ({ fenceKey, fenceIsValid, onChange }) => {
  return (
    <StringValue defaultValue={fenceKey} onChange={onChange}>
      {({ value, set }) => (
        <FlexRow styleOverrides={{ marginBottom: "2em" }}>
          <ButtonTabLabel>Type of Geofence:</ButtonTabLabel>
          <ButtonTab
            tabKey={"radial"}
            selectedKey={value}
            onClick={() => set("radial")}
          >
            Radial
          </ButtonTab>
          <ButtonTab
            tabKey={"polygonal"}
            selectedKey={value}
            onClick={() => set("polygonal")}
          >
            Polygonal
          </ButtonTab>
          <FenceValidityMarker isValid={fenceIsValid} />
        </FlexRow>
      )}
    </StringValue>
  );
};

const GeofenceEditForm = ({ data, mergeData, H }) => {
  const { geofence } = data;
  const fenceType = getType(geofence);
  const fenceIsValid = fenceType.isValid(geofence);
  return (
    <glamorous.Div display="flex" flexDirection="column">
      <GeofenceTypeToggleBar
        fenceKey={fenceType.name.toLowerCase()}
        fenceIsValid={fenceIsValid}
        onChange={typeName => {
          const typeConverterName = `to${_.capitalize(typeName)}`;
          const typeConverter = fenceType[typeConverterName];
          const newGeofence = typeConverter(geofence);
          console.log(typeConverterName, { newGeofence });
          mergeData({ geofence: newGeofence });
        }}
      />

      {fenceType === GeofenceType.RADIAL && (
        <RadialForm data={data} mergeData={mergeData} />
      )}
      {fenceType === GeofenceType.POLYGONAL && (
        <PolygonalForm data={data} mergeData={mergeData} />
      )}
    </glamorous.Div>
  );
};
GeofenceEditForm.propTypes = {
  data: PropTypes.shape({
    geofence: PropTypes.shape({
      geometry: PropTypes.shape({
        type: PropTypes.oneOf(allowedGeojsonFeatureTypes).isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  mergeData: PropTypes.func.isRequired
};

export default GeofenceEditForm;



// WEBPACK FOOTER //
// ./src/modules/geofence-edit/GeofenceEditForm.js